


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { LoginState, User } from '@/store/login/types';
import { IMessage } from '@/store/alert/types';
import { RootState } from '@/store/types';
import Alert from '@/components/Alert.vue';
import Cards from '@/components/Cards.vue';
import Input from '@/components/Input.vue';

const namespace: string = 'login';

@Component({
  components: {
    Alert,
    Cards,
    Input,
  },
})
export default class LoginForm extends Vue {
  @Action('login', { namespace }) private login: (user: User) => void;
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @State('login') private loginState?: LoginState;
  private user: User = { email: '', password: '' };

  public validateEmail(email: string) {
    var re = /\S+@\S+\.\S+/;
    return re.test(String(email).toLowerCase());
  }

  private onLogin(email: string, password: string) {
    if (this.user.email! !== '' && this.user.password! !== '') {
      if (this.validateEmail(this.user.email!)) {
        this.login({ email, password });
      } else {
        this.alert({
          prefix: 'INPUT_',
          error: 'NOT_EMAIL',
        });
      }
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }
}
